var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442);\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 1.41px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    x1: -128.91,
    y1: 162.92,
    x2: -127.83,
    y2: 161.82,
    gradientTransform: "translate(4123 5211) scale(32 -32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39c8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2588ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Promo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "cls-2",
    width: 32,
    height: 32,
    rx: 10.53,
    ry: 10.53
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-path-2",
    className: "cls-3",
    d: "M24.18,7.09c.34,.24,.52,1.31,.34,3.65-.06,.8-.17,1.64-.34,2.54,.79,1.38,1.01,2.95,.66,4.7-.32,1.55-1.35,3-3.01,4.39s-3.58,2.63-5.85,2.63-4.59-1.31-6-2.63c-1.41-1.32-2.3-2.57-2.71-3.96-.5-1.69-.33-3.4,.5-5.13-.18-.93-.29-1.78-.33-2.54-.17-2.81-.06-3.35,.33-3.65,.53-.4,2.23,.64,5.09,3.12,1.31-.24,2.35-.35,3.14-.35s1.82,.12,3.1,.35c2.88-2.43,4.57-3.47,5.08-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-1",
    d: "M15.96,20.96c-.69,.01-1.63-.93-1.63-1.31s1.1-.5,1.71-.5,1.63,.07,1.63,.5-1.01,1.3-1.71,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "cls-1",
    d: "M11.49,17.32c1,.39,2.02,.18,2.27-.48,.25-.66-.37-1.5-1.37-1.89-1-.39-1.86-.44-2.11,.22-.25,.66,.21,1.76,1.21,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy",
    className: "cls-1",
    d: "M20.48,17.2c-.95,.46-1.98,.29-2.23-.37-.25-.66,.37-1.5,1.37-1.89,1-.39,1.76-.44,2.01,.22,.25,.66-.2,1.58-1.15,2.04Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.41e277692249c9299cbbfeb2cc4f72de.svg";
export { ForwardRef as ReactComponent };